define((require) => {
    "use strict";

    var Backbone                       = require("backbone"),
        YouTubeImageModel              = require("ui/assets/youtube/YouTubeImageModel");

    /**
     * A collection of images.
     *
     * @author Antonio Lagrotteria
     * @class YouTubeImageCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: YouTubeImageModel
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/youtube/YouTubeImageCollection.js